import React from 'react';
import PropTypes from 'prop-types';

const Backward5SecPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5.72.28A.751.751 0 0 1 7 .811V3h7c7.18 0 13 5.82 13 13s-5.82 13-13 13c-3.834 0-7.281-1.66-9.693-4.333a.999.999 0 0 1 0-1.414l.706-.707a1.019 1.019 0 0 1 1.434.007A9.973 9.973 0 0 0 14 26c5.523 0 10-4.477 10-10S19.523 6 14 6H7v2.189c0 .199-.079.39-.22.53a.747.747 0 0 1-1.06 0L2.207 5.208a1 1 0 0 1 0-1.415L5.72.28zM10.66 10h6.8v2h-4.95l-.175 2.35a4.012 4.012 0 0 1 1.645-.349C16.2 14.001 18 15.792 18 18c0 2.21-1.8 4.001-4.02 4.001A4.015 4.015 0 0 1 10 18.57h2.041a2.001 2.001 0 1 0 .439-1.916h-2.318L10.66 10z"
    />
  );
};

Backward5SecPath.propTypes = {
  fill: PropTypes.string,
};

export default Backward5SecPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/backward-5-sec.jsx